// extracted by mini-css-extract-plugin
export default {"idCell":"DatabasePage_idCell__+Q-18","dataCell":"DatabasePage_dataCell__31NhI"};